module.exports = __webpack_public_path__ + "img/doggo2.ee66cc5a.jpg";